import {  useState } from 'react'
import { BASE_PATH_API } from 'constants/env';


const useProductsIDs = () => {
    const Domain = BASE_PATH_API

    const [responseProduct, setResponseProducts] = useState()

    const getProductsByFilter = async (ids) => {
        const idsFilter = String(ids)

        try {
            const response = await fetch(`${Domain}/products/v1/products?filter_by[id]=${idsFilter}&page_size=${idsFilter ? idsFilter.split(',')?.length : 20}`);
            const data = await response.json();
            setResponseProducts(data?.data)

        } catch (error) {
            console.error('Error fetching productsFilter data:', error);
        }
    }


    return {
        getProductsByFilter,
        responseProduct
    }
}

export default useProductsIDs